import React from "react";

export const FooterAddress = () => {
    return (
        <div className={'footer-address-wrap'}>
            <h2 className="address-title">
                Мы находимся по адресу:
            </h2>
            <address>
                Архангельская область, <br/> г. Мирный, ул. Циргвава, ТЦ Плаза 2 этаж
            </address>
            <p>Ежедневно с 11.00 - 20.00</p>
        </div>
    )
}